/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Partner_Customer_Invite_SentInputs */



/**
* | output |
* | --- |
* | "Invitation sent to {email}." |
*
* @param {Partner_Customer_Invite_SentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_invite_sent = /** @type {((inputs: Partner_Customer_Invite_SentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Invite_SentInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Einladung an ${i?.email} gesendet.`)
	return /** @type {LocalizedString} */ (`Invitation sent to ${i?.email}.`)
});